export default "__VITE_ASSET__CfBDL_Dk__"